<template>
    <div>
        <div class="c-config-content">
            <h4 class="c-config-content__title">{{title}}</h4>
            <p>{{desc}}</p>
            <h5>{{$t('addStatusFormTitle',[$t(type)])}}</h5>
            <form class="form-inline c-form-status mb-2" @submit.prevent="create" v-if="$store.state.user.permissions.includes('customStatusSetup')">
                <form-input class="mb-2 mb-md-0 mr-2" type="text"
                            :model="newFormModel" attribute="label" :errors="formErrors" :placeholder="$t('statusNamePlaceholder')"></form-input>
                <button :disabled="saveLoading" @click="create" class="btn btn-primary">{{$t('addStatus')}}</button>
            </form>
            <p class="text-muted">{{$t('draggable')}}</p>
            <div v-if="firstLoading">
                <skeleton-loading>
                    <row>
                        <square-skeleton :boxProperties="{bottom: '10px', height: '30px'}"></square-skeleton>
                    </row>
                    <row>
                        <square-skeleton :boxProperties="{bottom: '10px', height: '200px'}"></square-skeleton>
                    </row>
                </skeleton-loading>
            </div>
            <div class="c-template-table table-responsive c-role-table c-draggable-table" v-else>
                <table class="table table-hover is-content-top" v-if="$store.state.user.permissions.includes('customStatusSetup')">
                    <thead>
                        <tr>
                            <th>
                                {{$t('statusName')}}
                            </th>
                            <th class="text-right">

                            </th>
                        </tr>
                    </thead>
                    <tbody v-if="listLoading">
                        <tr>
                            <b-spinner></b-spinner>
                        </tr>
                    </tbody>
                    <tbody>
                        <tr v-if="type==='opp'">
                            <td>
                                <div class="toggle">
                                    <label>
                                        <input type="checkbox" checked="true" disabled="true">
                                            <span class="button-indecator"></span>
                                    </label>
                                </div>
                                <div v-if="fixFormModel.id && fixFormModel.id==='new'" class="c-role-table__content">
                                    <b-form-input v-focus type="text" :placeholder="$t('statusNamePlaceholder')" class="form-control mb-2 mb-md-0"
                                                  v-model="fixFormModel.label" v-on:keydown.enter="saveLabel" @keydown.esc="reset" />
                                </div>
                                <div v-else class="c-role-table__content" @click="updateLabel('new')">{{getLabel('new')}}</div>
                            </td>
                            <td class="text-right h-nowrap">
                                <div v-if="fixFormModel.id && fixFormModel.id==='new'">
                                    <button @click="saveLabel" :disabled="saveLoading" v-b-tooltip.hover.top="$t('save')"
                                            class="btn btn-outline-gray btn-sm is-border-1" type="button">
                                        <b-spinner v-if="saveLoading" small></b-spinner>
                                        <i class="fa fa-save mr-0"></i>
                                    </button>
                                    <button @click="reset" v-b-tooltip.hover.top="$t('cancel')"
                                            class="btn btn-outline-gray btn-sm is-border-1 ml-1" type="button">
                                        <i class="fa fa-times mr-0"></i>
                                    </button>
                                </div>
                                <div v-else>
                                    <button :disabled="updateLoading" v-b-tooltip.hover.top="$t('edit')"
                                            @click="updateLabel('new')" class="btn btn-outline-gray btn-sm is-border-1" type="button">
                                        <b-spinner v-if="updateLoading" small></b-spinner>
                                        <i class="icon12-edit-primary" v-else></i>
                                    </button>
                                </div>
                            </td>
                        </tr>
                        <tr v-if="type==='customer'">
                            <td>
                                <div class="toggle">
                                    <label>
                                        <input type="checkbox" checked="true" disabled="true">
                                            <span class="button-indecator"></span>
                                    </label>
                                </div>
                                <div v-if="fixFormModel.id && fixFormModel.id==='default'" class="c-role-table__content">
                                    <b-form-input v-focus type="text" :placeholder="$t('statusNamePlaceholder')" class="form-control mb-2 mb-md-0"
                                                  v-model="fixFormModel.label" v-on:keydown.enter="saveLabel" @keydown.esc="reset"/>
                                </div>
                                <div v-else class="c-role-table__content" @click="updateLabel('default')">{{getLabel('default')}}</div>
                            </td>
                            <td class="text-right h-nowrap">
                                <div v-if="fixFormModel.id && fixFormModel.id==='default'">
                                    <button @click="saveLabel" :disabled="saveLoading" class="btn btn-outline-gray btn-sm is-border-1" type="button">
                                        <b-spinner v-if="saveLoading" small></b-spinner>
                                        <i class="fa fa-save mr-0"></i>
                                    </button>
                                    <button @click="reset" class="btn btn-outline-gray btn-sm is-border-1" type="button">
                                        <i class="fa fa-times mr-0"></i>
                                    </button>
                                </div>
                                <div v-else>
                                    <button :disabled="updateLoading" @click="updateLabel('default')" class="btn btn-outline-gray btn-sm is-border-1" type="button">
                                        <b-spinner v-if="updateLoading" small></b-spinner>
                                        <i class="icon12-edit-primary" v-else></i>
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                    <draggable v-model="items" @change="draggableChange" v-if="items.length && !listLoading" tag="tbody">
                        <tr class="tr-draggable" v-for="item in items" :key="item._id">
                            <td>
                                <div class="toggle">
                                    <label>
                                        <input @change="changeStatus(item._id)" type="checkbox" :checked="item.active">
                                            <span class="button-indecator"></span>
                                    </label>
                                </div>
                                <div v-if="formModel.id && formModel.id===item._id" class="c-role-table__content">
                                    <b-form-input v-focus type="text" :placeholder="$t('statusNamePlaceholder')" class="form-control mb-2 mb-md-0"
                                                  v-model="formModel.label" v-on:keydown.enter="save" @keydown.esc="reset"/>
                                </div>
                                <div v-else class="c-role-table__content" @click="update(item._id)">{{item.label}}</div>
                                <div v-if="delFormModel.id && delFormModel.id===item._id" class="c-remove-info">
                                    <p>{{$t('delOppStatusMsg')}}</p>
                                    <div class="input-group">
                                        <b-form-select v-model="delFormModel.key" :options="delFormModel.statusOptions" class="form-control custom-select"></b-form-select>
                                        <div class="input-group-append">
                                            <button @click="delOppConfirm" :disabled="delLoading" class="btn btn-primary" type="button">
                                                <b-spinner v-if="delLoading" small></b-spinner>
                                                {{$t('confirm')}}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td class="text-right h-nowrap">
                                <div v-if="formModel.id && formModel.id===item._id">
                                    <button @click="save" :disabled="saveLoading" class="btn btn-outline-gray btn-sm is-border-1" type="button">
                                        <b-spinner v-if="saveLoading" small></b-spinner>
                                        <i class="fa fa-save mr-0"></i>
                                    </button>
                                    <button @click="reset" class="btn btn-outline-gray btn-sm is-border-1" type="button">
                                        <i class="fa fa-times mr-0"></i>
                                    </button>
                                </div>
                                <div v-else>
                                    <button v-if="type!=='opp'" :disabled="delLoading" @click="del(item._id)" class="mr-1 btn btn-outline-gray btn-sm is-border-1" type="button">
                                        <b-spinner v-if="delLoading" small></b-spinner>
                                        <i class="icon12-delete-primary" v-else></i>
                                    </button>
                                    <button v-if="type==='opp' && !(!delFormModel.id || delFormModel.id!==item._id)" @click="resetOpp" class="btn btn-outline-gray btn-sm is-border-1" type="button">
                                        <i class="fa fa-times mr-0"></i>
                                    </button>
                                    <button v-if="type==='opp' && (!delFormModel.id || delFormModel.id!==item._id)"
                                            :disabled="delLoading" @click="delOpp(item._id, item.key)" v-b-tooltip.hover.top="$t('delete')"
                                            class="mr-1 btn btn-outline-gray btn-sm is-border-1" type="button">
                                        <b-spinner v-if="delLoading" small></b-spinner>
                                        <i class="icon12-delete-primary" v-else></i>
                                    </button>
                                    <button v-if="(!delFormModel.id || delFormModel.id!==item._id)"
                                            :disabled="updateLoading" @click="update(item._id)" v-b-tooltip.hover.top="$t('edit')"
                                            class="btn btn-outline-gray btn-sm is-border-1" type="button">
                                        <b-spinner v-if="updateLoading" small></b-spinner>
                                        <i class="icon12-edit-primary" v-else></i>
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </draggable>
                    <tbody>
                        <tr v-if="type==='opp'">
                            <td>
                                <div class="toggle">
                                    <label>
                                        <input type="checkbox" checked="true" disabled="true">
                                            <span class="button-indecator"></span>
                                    </label>
                                </div>
                                <div v-if="fixFormModel.id && fixFormModel.id==='won'" class="c-role-table__content">
                                    <b-form-input v-focus type="text" :placeholder="$t('statusNamePlaceholder')" class="form-control mb-2 mb-md-0"
                                                  v-model="fixFormModel.label" v-on:keydown.enter="saveLabel" @keydown.esc="reset"/>
                                </div>
                                <div v-else class="c-role-table__content" @click="updateLabel('won')">{{getLabel('won')}}</div>
                            </td>
                            <td class="text-right h-nowrap">
                                <div v-if="fixFormModel.id && fixFormModel.id==='won'">
                                    <button @click="saveLabel" :disabled="saveLoading" v-b-tooltip.hover.top="$t('save')"
                                            class="btn btn-outline-gray btn-sm is-border-1" type="button">
                                        <b-spinner v-if="saveLoading" small></b-spinner>
                                        <i class="fa fa-save mr-0"></i>
                                    </button>
                                    <button @click="reset" v-b-tooltip.hover.top="$t('cancel')"
                                            class="btn btn-outline-gray btn-sm is-border-1 ml-1" type="button">
                                        <i class="fa fa-times mr-0"></i>
                                    </button>
                                </div>
                                <div v-else>
                                    <button :disabled="updateLoading" @click="updateLabel('won')" v-b-tooltip.hover.top="$t('edit')"
                                            class="btn btn-outline-gray btn-sm is-border-1" type="button">
                                        <b-spinner v-if="updateLoading" small></b-spinner>
                                        <i class="icon12-edit-primary" v-else></i>
                                    </button>
                                </div>
                            </td>
                        </tr>
                        <tr v-if="type==='opp'">
                            <td>
                                <div class="toggle">
                                    <label>
                                        <input type="checkbox" checked="true" disabled="true">
                                            <span class="button-indecator"></span>
                                    </label>
                                </div>
                                <div v-if="fixFormModel.id && fixFormModel.id==='lost'" class="c-role-table__content">
                                    <b-form-input v-focus type="text" :placeholder="$t('statusNamePlaceholder')" class="form-control mb-2 mb-md-0"
                                                  v-model="fixFormModel.label" v-on:keydown.enter="saveLabel" @keydown.esc="reset"/>
                                </div>
                                <div v-else class="c-role-table__content" @click="updateLabel('lost')">{{getLabel('lost')}}</div>
                            </td>
                            <td class="text-right h-nowrap">
                                <div v-if="fixFormModel.id && fixFormModel.id==='lost'">
                                    <button @click="saveLabel" :disabled="saveLoading" v-b-tooltip.hover.top="$t('save')"
                                            class="btn btn-outline-gray btn-sm is-border-1" type="button">
                                        <b-spinner v-if="saveLoading" small></b-spinner>
                                        <i class="fa fa-save mr-0"></i>
                                    </button>
                                    <button @click="reset" v-b-tooltip.hover.top="$t('cancel')"
                                            class="btn btn-outline-gray btn-sm is-border-1 ml-1" type="button">
                                        <i class="fa fa-times mr-0"></i>
                                    </button>
                                </div>
                                <div v-else>
                                    <button :disabled="updateLoading" v-b-tooltip.hover.top="$t('edit')"
                                            @click="updateLabel('lost')" class="btn btn-outline-gray btn-sm is-border-1" type="button">
                                        <b-spinner v-if="updateLoading" small></b-spinner>
                                        <i class="icon12-edit-primary" v-else></i>
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                    <tbody v-if="!items.length && type==='customer'">
                        <tr>
                            <td colspan="3" class="text-center">{{$t('noStatusCreated')}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    import list from '../../../mixins/List';
    import crud from '../../../mixins/CRUD';
    import utils from '../../../utils';
    import draggable from 'vuedraggable';

    export default {
        components: {draggable},
        mixins: [list, crud, utils],
        props: {
            type: {type: String},
            title: {type: String},
            desc: {type: String},
        },
        directives: {
            focus: {
                inserted: function (cs) {
                    cs.focus()
                }
            }
        },
        data: function () {
            return {
                client: {},
                service: '/client-custom-status/' + this.type,
                reloadBus: 'loadCustomStatus',
                autoLoad: true,
                defaultFormModel: {
                    label: '',
                    key: '',
                    active: true,
                    position: 1
                },
                newFormModel: {
                    label: '',
                },
                fixFormModel: {
                    id: '',
                    label: ''
                },
                delFormModel: {
                    id: '',
                    key: '',
                    statusOptions: []
                },
            };
        },
        methods: {
            create: function () {
                this.formErrors = [];
                this.formModel = {};
                this.formModel = Object.assign({}, this.formModel, this.defaultFormModel);
                this.formModel.label = this.newFormModel.label;
                this.formModel.key = this.$utils.createAlias(this.formModel.label);
                this.formModel.positon = this.items.length + 1;
                this.saveLoading = true;
                this.$service({url: this.service, method: 'post', data: this.formModel}).then(response => {
                    this.newFormModel.label = '';
                    this.load();
                    if (this.reloadBus) {
                        this.$bus.$emit(this.reloadBus);
                    }
                    if (response.data) {
                        this.$swal({
                            title: this.$t('success'),
                            text: this.$t(this.formModel.id ? 'updated' : 'created'),
                            icon: 'success',
                            toast: true,
                            position: 'top-end',
                            timer: 5000,
                        });
                    } else {
                        this.$swal({
                            title: this.$t('error'),
                            text: this.$t(this.formModel.id ? 'updateFailed' : 'createFailed'),
                            icon: 'error',
                            toast: true,
                            position: 'top-end',
                            timer: 5000,
                        });
                    }
                }).catch(error => {
                    if (error.response.data.message) {
                        this.$swal({
                            text: error.response.data.message,
                            icon: 'error'
                        });
                    } else {
                        this.formErrors = error.response.data;
                    }
                }).finally(() => {
                    this.saveLoading = false;
                });
            },
            update: function (id) {
                this.updateLoading = true;
                this.$service.get(this.service + '/' + id).then(response => {
                    this.formModel = {};
                    this.formErrors = [];
                    this.formModel = response.data;
                    this.formModel.id = id;
                }).finally(() => {
                    this.updateLoading = false;
                });
            },
            save: function () {
                this.saveLoading = true;
                this.$service({url: this.service + '/' + this.formModel.id, method: "put", data: this.formModel}).then(response => {
                    this.formModel = {};
                    this.formErrors = [];
                    this.load();
                    if (this.reloadBus) {
                        this.$bus.$emit(this.reloadBus);
                    }
                    if (response.data) {
                        this.$swal({
                            title: this.$t('success'),
                            text: this.$t('updated'),
                            icon: 'success',
                            toast: true,
                            position: 'top-end',
                            timer: 5000,
                        });
                    } else {
                        this.$swal({
                            title: this.$t('error'),
                            text: this.$t('updateFailed'),
                            icon: 'error',
                            toast: true,
                            position: 'top-end',
                            timer: 5000,
                        });
                    }
                }).catch(error => {
                    if (error.response.data.message) {
                        this.$swal({
                            text: error.response.data.message,
                            icon: 'error'
                        });
                    } else {
                        this.formErrors = error.response.data;
                    }
                }).finally(() => {
                    this.saveLoading = false;
                });
            },
            changeStatus: function (id) {
                this.$bgService.post(this.service + '/active/' + id).then(response => {
                    if (response.data) {
                        if (this.load) {
                            this.load();
                        }
                    }
                }).catch(error => {
                    if (error.response.data.msg) {
                        this.$swal({
                            text: error.response.data.msg,
                            icon: 'error'
                        });
                    }
                });
            },
            reset: function () {
                this.formModel = {};
                this.fixFormModel = {};
                this.formErrors = [];
            },
            draggableChange: function () {
                let data = [];
                this.items.forEach(item => {
                    data.push({id: item._id, position: data.length, key: item.key});
                });
                this.$service({url: this.service + '/position', method: 'post', data: data}).catch(error => {
                    if (error.response.data.msg) {
                        this.$swal({
                            text: error.response.data.msg,
                            icon: 'error'
                        });
                    }
                });
            },
            updateLabel: function (type) {
                // hàm này nhận vào new/won/lost và update label tương ứng của Client
                this.fixFormModel = {};
                this.fixFormModel.id = type;
                this.fixFormModel.label = this.getLabel(type);
            },
            getLabel: function (type) {
                //hàm này lấy về các giá trị của newLabel, wonLabel, lostLabel của Client
                if (type === 'won') {
                    return this.client.wonLabel ? this.client.wonLabel : this.$t('wonLabel');
                } else if (type === 'lost') {
                    return this.client.lostLabel ? this.client.lostLabel : this.$t('lostLabel');
                } else if (type === 'new') {
                    return this.client.newLabel ? this.client.newLabel : this.$t('newLabel');
                } else if (type === 'default') {
                    return this.client.defaultCustomerStatusLabel ? this.client.defaultCustomerStatusLabel : this.$t('newCustomer');
                }
                return '';
            },
            saveLabel: function () {
                this.saveLoading = true;
                this.$service({url: this.service + '/label', method: "post", data: this.fixFormModel}).then(response => {
                    this.fixFormModel = {};
                    this.formErrors = [];
                    if (this.reloadBus) {
                        this.$bus.$emit(this.reloadBus);
                    }
                    this.getClient();
                    if (response.data) {
                        this.$swal({
                            title: this.$t('success'),
                            text: this.$t('updated'),
                            icon: 'success',
                            toast: true,
                            position: 'top-end',
                            timer: 5000,
                        });
                    } else {
                        this.$swal({
                            title: this.$t('error'),
                            text: this.$t('updateFailed'),
                            icon: 'error',
                            toast: true,
                            position: 'top-end',
                            timer: 5000,
                        });
                    }
                }).catch(error => {
                    if (error.response.data.message) {
                        this.$swal({
                            text: error.response.data.message,
                            icon: 'error'
                        });
                    } else {
                        this.formErrors = error.response.data;
                    }
                }).finally(() => {
                    this.saveLoading = false;
                });
            },
            getClient: function () {
                this.$service('/client').then(response => {
                    this.client = response.data;
                }).catch(error => {
                    if (error.response.data.msg) {
                        this.$swal({
                            text: error.response.data.msg,
                            icon: 'error'
                        });
                    }
                });
            },
            delOpp: function (id, k) {
                let result = [{value: '', text: this.$t('selectStatus')}];
                for (let i = 0; i < this.$store.state.opportunityStatus.length; i++) {
                    let key = this.$store.state.opportunityStatus[i].value;
                    if (key !== k) {
                        result.push(this.$store.state.opportunityStatus[i]);
                    }
                }
                this.delLoading = true;
                this.$service.get(this.service + '/' + id).then(response => {
                    this.delFormModel = {};
                    this.delFormModel = response.data;
                    this.delFormModel.key = '';
                    this.delFormModel.statusOptions = result;
                    this.delFormModel.id = id;
                }).finally(() => {
                    this.delLoading = false;
                });
            },
            delOppConfirm: function () {
                if (this.delFormModel.key === null || this.delFormModel.key === '') {
                    this.$swal({
                        title: this.$t('pleaseChooseAStatus'),
                        icon: 'warning'
                    });
                    return false;
                } else {
                    this.delLoading = true;
                    this.$service.delete(this.service + '/' + this.delFormModel.id + '?ref=' + this.delFormModel.key).then(response => {
                        if (response.data) {
                            if (this.load) {
                                this.load();
                            }
                            if (this.reloadBus) {
                                this.$bus.$emit(this.reloadBus);
                            }
                            this.$swal({
                                title: this.$t('success'),
                                text: this.$t('deleted'),
                                icon: 'success',
                                toast: true,
                                position: 'top-end',
                                timer: 5000,
                            });
                        } else {
                            this.$swal({
                                title: this.$t('error'),
                                text: this.$t('deleteFailed'),
                                icon: 'error',
                            });
                        }
                    }).catch(error => {
                        if (error.response.data.message) {
                            this.$swal({
                                text: error.response.data.message,
                                icon: 'error'
                            });
                        }
                    }).finally(() => {
                        this.delLoading = false;
                    });
                }
            },
            resetOpp: function () {
                this.delFormModel = {};
            },
        },
        mounted: function () {
            this.getClient();
        }
    }
</script>